var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 h-20",class:{ selected: _vm.isSelected },on:{"click":function($event){_vm.selectIcon()}}},[_c('center',[_c('img',{staticClass:"img-fluid",attrs:{"src":require('../../assets/images/icons/' + _vm.image + '.png')}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ceaa73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Selections.vue
// module id = null
// module chunks = 